import { format } from 'date-fns'
import { TFunction } from 'react-i18next'
import { OptionGroupService } from '../../../../../../service/optionGroup'
import { Constants } from '../../../../../../utils/constants'
import { httpFetch } from '../../../../../../utils/crud'
import { RequestErrors, Types } from '../../../../../../utils/enums'
import { Color } from '../../../../../../utils/theme/types/color'
import { ObjectGeneric } from '../../../../../../utils/types/generals'
import { isRequired, searchInModeLower } from '../../../../../../utils/validate/validate'
import { handleAllErrors } from '../../../../../../utils/methods/handleErrors'
import { OptionTableRow } from '../../../../../../service/optionGroup/reponse'
import { sharedAws } from '../../../../../../service/bucketS3/Storage'
import { TemplateType } from '../../enums'
import { DropDownLink } from '../../components/catalogOption/typpes'

export const getList = async (colors: Color, t: TFunction<'translation', undefined>,query?:string) => {
  const data = await OptionGroupService(httpFetch).getOptionGroup(query)
  
  const row: OptionTableRow[] = !data?.errors
    ? data?.items.map((item) => {
      return {
        id: item?.id,
        optionsCount: item?.optionsCount ?? '0',
        name: item?.title,
        createTime: format(new Date(item.createTime), Constants.dateFormatGeneral),
      }
    })
    : []
  const totalPages = data.totalPages

  return { row, totalPages }
}

export const filterRow = (value: { [x: string]: any }, list: any[]) => {
  const from = value.from?.valueOf()
  const to = value.to?.valueOf()
  return list?.filter((item) => {
    return (
      (from ? new Date(from).setHours(0, 0, 0, 0) <= Date.parse(item?.create_time) : true) &&
      (to ? new Date(to).setHours(23, 59, 59, 999) >= Date.parse(item?.create_time) : true) &&
      (value?.month instanceof Array ? (value?.month.length > 0 ? value?.month.find((e: any) => e.value === item.monthNumber) : true) : true) &&
      (value?.createYear instanceof Array ? (value?.createYear.length > 0 ? value?.createYear.find((e: any) => e.value === item.createYear) : true) : true) &&
      ((value?.search ? searchInModeLower(item?.title, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.optionNumber, value?.search) : true))
    )
  })
}

export const handleErrors = (values: any, t: any, ignore?: string[]) => {
  let error = {} as ObjectGeneric
  if (values.title !== null && isRequired(values.title)) error.title = t('optionGroup.tags.errors.optionName')

  if (values.description !== null && isRequired(values.description)) error.description = t('general.validations.required')

  return error
}

export const submit = async ({ id, t, title, options, template, dropLinks, force }:{ force?:boolean; dropLinks?: DropDownLink[]; template:TemplateType; title:string,  options?: { description: string; icon: string | File | null; id: number; }[], t: TFunction<'translation', undefined>, id: number | null}) => {
  let snackbarBody = {
    open: false,
    openModal: false,
    type: Types.SUCCESS,
    message: '',
  }
  let copyOptions = options

  const body = {
    title: title,
    ...(id == null && { type_option_group_id: template }),
    drop_downs_links: dropLinks ??  null,
    options: options ? await Promise.all(
      options.map(async (item: any) => ({
        description: item.description,
        iconUrl: item?.icon?.name ?
          await sharedAws.uploadAndGetUrl({ file: item.icon, name: `${new Date().getTime()}`, otherBucket: process.env.REACT_APP_BUCKET_ICON_QUESTIONNARIES }) : item?.icon,
      }))
    ) : null,
  } as any

  let response: any

  if (id) {
    response = await OptionGroupService(httpFetch).updateOptionGroup(body, id, force)
  } else {
    response = await OptionGroupService(httpFetch).createOptionGroup(body)
  }

  if (response.errors) {
    copyOptions = copyOptions?.map((item, index) => ({
      ...item,
      icon: body.options?.[index]?.iconUrl ?? item.icon,
    }))
    const inUse = response?.errors?.[0]?.code === RequestErrors.ERR_OPTION_GROUP_IN_USE
    snackbarBody = {
      open: !inUse,
      openModal: inUse,
      type: Types.ERROR,
      message: `${handleAllErrors(response?.errors?.[0]?.code ?? '', t, `optionGroup.snackbar.${id ? 'update' : 'create'}.error`)} ${inUse ? t('general.createNew') : ''}`,
    }
  } else {
    snackbarBody = {
      open: true,
      openModal: false,
      type: Types.SUCCESS,
      message: t(`optionGroup.snackbar.${id ? 'update' : 'create'}.success`),
    }
  }
  return {
    snackbarBody,
    response: {
      response,
      copyOptions,
    },
  }
}
